`<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col cols="auto" class="pa-0">
                    <category-list v-model="category" return-object/>
                </v-col>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <h2 class="tit">쿠폰 교환소</h2>
                            </div>

                            <div class="font-size-14 font-size-md-16 grey--text text--garken-3 mt-md-n20px mb-20px mb-md-30px">
                                <p>* 본인인증을 진행한 후 30분 동안 구매 가능합니다.</p>
                                <p>* 구매전 본인인증을 진행해주세요</p>
                            </div>

                            <div v-if="category?.code === 'department' || !category?.code" class="mb-30px mb-md-40px">
                                <v-btn-toggle v-if="category?.code === 'department' || !category?.code" class="d-flex">
                                    <v-flex xs6 class="v-btn px-0"><v-btn width="100%" :color="mode == 'mobile' ? 'primary': 'white'" x-large tile elevation="0" @click="mode = 'mobile'">모바일</v-btn></v-flex>
                                    <v-flex xs6 class="v-btn px-0"><v-btn width="100%" :color="mode == 'paper'  ? 'primary': 'white'" x-large tile elevation="0" @click="mode = 'paper'" >지류</v-btn></v-flex>
                                </v-btn-toggle>
                            </div>

                            <giftcard-list :category="category" :mode="mode"/>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <!-- <popup-layer skin="gshop"/> -->

        <v-dialog v-if="!me?.ci" v-model="dialog" max-width="500" :width="$vuetify.breakpoint ? '50%' : '90%' " scrollable>
            <v-card>
                <a href="/mypage/profile"><v-img src="/images/gshoppopup2.jpg"/></a>
                <div class="popup-layer-foot" style="display: flex; background-color: #424242; padding: 10px;">
                    <!-- <label class="check check-light">
                        <input v-model="checkbox" class="input" type="checkbox" :value="true"/>
                        <i class="icon"></i>
                        <span style="color:white" class="text"> 오늘하루 열지않음</span>
                    </label> -->
                    <!-- <div></div> -->
                    <v-spacer></v-spacer>
                    <v-btn text @click="close" style="color:white; font-size: 16px;">닫기</v-btn>
                </div>
            </v-card>
        </v-dialog>
        <popup-layer code="gshop"/>
    </component>
</template>
<script>
import CategoryList from "@/components/client/gshop/category/category-list.vue";
import GiftcardList from "@/components/client/gshop/giftcard/giftcard-list.vue";
import PopupLayer from '@/components/client/popup/popup-layer.vue';
import api from "@/api";
import { mdiClose } from '@mdi/js';

export default {
    components: {
        CategoryList,
        GiftcardList,
        PopupLayer
    },
    data(){
        return {
            mdiClose,

            checkbox: false,
            category: null,
            mode: "mobile",
            dialog: true,
            me: null
        }
    },
    mounted() {
		this.dialog = !this.$cookies.get('dialog');
        this.init()
	},
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    methods: {
        async init(){
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        },
        close(){
            // if(this.checkbox){
            //     this.$cookies.set('dialog', "hidden", "1d");
            // }
            this.dialog = false
        }
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        },
    },
    watch: {
        dialog(){
            if(!this.me.ci && !this.dialog){
                this.$router.push('/mypage/profile')
            }
        }
    }
}
</script>

<style scoped>
</style>